// Shared formatters used across patientDetail sub-components. Kept as pure
// functions so no React import is needed and unit-testing is trivial.

export function fmtDate(iso) {
  if (!iso) return "—";
  if (iso.length === 10) {
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
  }
  return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function scoreLabel(s) {
  if (!s) return null;
  return s.percentage != null ? `${s.percentage}%` : `${s.total} / ${s.max}`;
}
